<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "UserForm" });
import { Form } from "../../../../components/index.js";
import { createEventDispatcher } from "svelte";
import * as API from "../../services/api.js";
export let user = {};
export let action = "create";
export let beforeSave = () => {
};
const dispatch = createEventDispatcher();
let formElement = null;
const onSave = (response) => {
    if ("code" in response) {
        return;
    }
    dispatch("save", response);
};
const onSubmit = async () => {
    await beforeSave();
    if (action === "update") {
        onSave(await API.updateUser({ userKey: user._.key }, user));
        return;
    }
    onSave(await API.createUser(user));
};
export const submit = async () => {
    if (formElement === null) {
        return;
    }
    await formElement.submit();
};
export const isValid = () => {
    if (formElement === null) {
        return false;
    }
    return formElement.isValid();
};
</script>

<Form { onSubmit } id = { `${ action }-user` } bind:this = { formElement }>

    <slot>
        <h3>{ action } User</h3>
        <pre>{ JSON.stringify(user, null, 2) }</pre>
    </slot>

</Form>